import React, { useMemo, useCallback } from "react";
import { preferredColumnOrder } from "../utils/csvUtils";
import { toCsvValue } from "../utils/csvUtils";
import { toReadableTime } from "../utils/dateTimeUtils";

export const SimpleTable = React.memo(function SimpleTable({
  rows,
  height = 260,
  onRowClick,
  trailingHeader,
  renderTrailingCell,
}) {
  const normalized = useMemo(() => (Array.isArray(rows) ? rows : []), [rows]);
  const trailHead = renderTrailingCell ? (trailingHeader || "Actions") : "";
  const columns = useMemo(() => {
    const sample = normalized.slice(0, 50);
    const set = new Set();
    for (const r of sample) {
      Object.keys(r || {}).forEach((k) => {
        // Filter out columns starting with underscore (internal use only)
        if (!k.startsWith("_")) {
          set.add(k);
        }
      });
    }
    return preferredColumnOrder(Array.from(set));
  }, [normalized]);

  const handleRowClick = useCallback((row) => {
    if (onRowClick) onRowClick(row);
  }, [onRowClick]);

  return (
    <div className="nr-tableWrap" style={{ maxHeight: height }}>
      {normalized.length === 0 ? (
        <div className="nr-muted" style={{ padding: 12 }}>
          No rows.
        </div>
      ) : (
        <table className="nr-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c}>{c}</th>
              ))}
              {trailHead ? <th>{trailHead}</th> : null}
            </tr>
          </thead>
          <tbody>
            {normalized.map((r, idx) => (
              <tr key={idx} onClick={() => handleRowClick(r)} style={{ cursor: onRowClick ? "pointer" : "default" }}>
                {columns.map((c) => {
                  const v = r?.[c];
                  let txt = v;
                  if (c === "claimedAt" || c === "createdAt" || c === "lastClaimAt" || c === "lastClaimSec" || c === "startTimeSec" || c === "endTimeSec") {
                    txt = toReadableTime(v);
                  }
                  return <td key={c}>{typeof txt === "string" ? txt : toCsvValue(txt) || "—"}</td>;
                })}
                {renderTrailingCell ? (
                  <td
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {renderTrailingCell(r, idx)}
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
});
